export default "__VITE_ASSET__DwFM09T5__"